<template>
  <div v-if="list && list.length > 0" class="p-t-20">
    <div class="home-two-title">
      <div class="text">
        <slot>精品课程</slot>
      </div>
      <span class="more" @click="zhibokes">查看更多&nbsp;></span>
    </div>
    <div v-if="list && list.length > 0" class="live">
      <div v-for="(item, index) in list" :key="index" class="item" @click="goPage(item)">
        <img class="item-img" :src="item.surfacePlot">
        <div class="detail">
          <div class="detail-title twoEllipsis">{{ item.commodityName }}</div>
          <div class="flex-c m-t-12">
            <div class="item-tips elp">{{ item.belongCollegeName }} · {{ item.belongProjectName }}</div>
          </div>

          <div class="flex-between-c price-box">
            <div class="price"><span class="price-icon">￥</span>{{ item.currentPrice }}</div>
            <div class="tips">人气值 {{ item.browseFrequency ? item.browseFrequency : 0 }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script> 
import '@/assets/css/common.css'
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: {},
  data() {
    return {
      list: [] // 公开课
    }
  },
  created() {
    homeClient.qbsJxyCourse({pageNum: 1, pageSize: 6}).then((res) => {
      this.list = res.data.rows
    })
  },
  methods: {
    zhibokes() {
      const routeUrl = this.$router.resolve({
        path: '/jingpin/courer'
      })
      window.open(routeUrl.href, '_blank')
    },
    goPage(item) {
      if (!item) {
        return
      }
      if (item.teachingMethod == 1) {
        const routeUrl = this.$router.resolve({
          path: `/zhiboclassxq?id=${item.id}`
        })
        window.open(routeUrl.href, '_blank')
      } else if (item.teachingMethod == 2) {
        const routeUrl = this.$router.resolve({
          path: `/videoxq?id=${item.id}`
        })
        window.open(routeUrl.href, '_blank')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.home-two-title {
  width: 1220px !important;
  padding-bottom: 4px;
  padding-top: 0px;
}

.live {
  width: 1244px;
  margin-left: calc(50% - 610px);
  flex-wrap: wrap;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .item {
    margin-bottom: 24px;
    width: 224px;
    height: 305px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    margin-right: 24px;
    overflow: hidden;
    cursor: pointer;

    &:hover {
      box-shadow: 0px 4px 8px 1px rgba(153, 153, 153, 0.20000000298023224);
    }

    .item-img {
      width: 224px;
      height: 126px;
      border-radius: 8px 8px 0px 0px;
      opacity: 1;
    }

    .detail {
      padding: 12px 16px;

      .detail-title {
        height: 48px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #333333;
        font-size: 16px;
        line-height: 24px;
      }

      .item-tips {
        height: 20px;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #ff7b1c;
        font-size: 12px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #ff7b1c;
        line-height: 18px;
        padding: 0px 8px;
      }

      .item-tips+.item-tips {
        margin-left: 8px;
      }

      .tips {
        font-size: 14px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #999999;
        line-height: 14px;
      }

      .price-box {
        margin-top: 24px;

        .price {
          font-family: Microsoft YaHei-Regular;
          color: #ff5d51;
          font-size: 24px;
          line-height: 24px;
          font-weight: Bold;

          .price-icon {
            font-size: 14px;
            line-height: 14px;
            font-weight: 400;
          }
        }
      }
    }
  }
}
</style>
